import { useTranslation } from 'next-i18next';
import React from 'react';

import TeamHeader from '@/modules/workingDay/components/Details/TeamList/TeamHeader';
import TeamMember from '@/modules/workingDay/components/Details/TeamList/TeamMember';
import { IWorkingDay } from '@/modules/workingDay/types';
import { Typography } from '@/shared/components/atoms';
import Collapse from '@/shared/components/atoms/Collapse';

interface Props {
  list: IWorkingDay.IJobInstanceSupplier[];
  productivityMeasurementUnit: string;
}

const TeamList: React.FC<Props> = ({ list, productivityMeasurementUnit }) => {
  const { t } = useTranslation('common');

  return (
    <section>
      <Typography variant='h3' weight='bold'>
        {t('teams')}
      </Typography>
      <div className='mt-14 flex flex-col gap-16'>
        {list?.map((team) => (
          <Collapse
            header={
              <TeamHeader
                team={team}
                productivityMeasurementUnit={productivityMeasurementUnit}
              />
            }
            key={team.supplierId}
            childrenClassName='bg-white'
          >
            <div className='mt-9 rounded-lg border-xs border-background-200 [&>*:nth-child(even)]:bg-background-neutral-100 [&>*:nth-child(odd)]:bg-white'>
              {team?.workers?.map((worker) => (
                <TeamMember
                  worker={worker}
                  key={worker.workerId}
                  productivityMeasurementUnit={productivityMeasurementUnit}
                  target={team.averageTargetPerDay / team?.workers?.length}
                />
              ))}
            </div>
          </Collapse>
        ))}
      </div>
    </section>
  );
};
export default TeamList;
